import type { ChangeEventHandler } from "react";
import { FieldShell } from "./FieldShell";
import { fieldIds, inputClass, resolveFieldState } from "./fieldStyles";

interface TextInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string | null;
  hint?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  maxLength?: number;
  autoComplete?: string;
  size?: "default" | "sm";
  hideLabel?: boolean;
  containerClassName?: string;
  children?: never;
}

export function TextInput({ id, label, value, onChange, onBlur, error, hint, required, readOnly, placeholder, maxLength, autoComplete = "off", size = "default", hideLabel, containerClassName }: TextInputProps) {
  const ids = fieldIds(id, error, hint);
  const state = resolveFieldState({ error, readOnly });

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => onChange(event.currentTarget.value);

  return (
    <FieldShell id={id} label={label} required={required} hint={hint} hintId={ids.hintId} error={error} errorId={ids.errorId} containerClassName={containerClassName} hideLabel={hideLabel}>
      <input
        id={id}
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        maxLength={maxLength}
        autoComplete={autoComplete}
        readOnly={readOnly}
        aria-required={required || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={ids.describedBy}
        className={inputClass(state, size)}
      />
    </FieldShell>
  );
}
